import { render, staticRenderFns } from "./CreateCompensationReview.vue?vue&type=template&id=64938a6b"
import script from "./CreateCompensationReview.vue?vue&type=script&lang=js"
export * from "./CreateCompensationReview.vue?vue&type=script&lang=js"
import style0 from "./CreateCompensationReview.vue?vue&type=style&index=0&id=64938a6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports